import { SharingData } from '../../schema/SharingData';
import isAfter from 'owa-datetime/lib/owaDate/isAfter';
import now from 'owa-datetime/lib/userDate/now';

export function isExpiring(sharingData: SharingData): boolean {
    return (
        sharingData &&
        sharingData.sharingInfo &&
        !!sharingData.sharingInfo.expirationDate &&
        isAfter(sharingData.sharingInfo.expirationDate, now())
    );
}
